<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template v-slot:default="{ open }">
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-account-multiple</v-icon> {{ $t('message.product.suppliers') }}</v-col>
          <v-col cols="8" class="text-right pr-6">
            <v-fade-transition leave-absolute>
              <span v-if="!open" key="0">{{ $t('message.common.total') }}: {{ listOfSupplierItems.length }}</span>
            </v-fade-transition>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <v-form ref="contactsForm">
        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12" md="2" lg="1">
              <v-btn color="primary" @click="addNewSupplier" class="mt-1">{{ $t('message.common.addNew') }}</v-btn>
            </v-col>
            <v-col cols="12" md="2" lg="1" class="text-right">
              <v-btn color="info" :loading="supplierExportLoading" @click="exportSuppliers" class="mt-1">{{ $t('message.common.export') }}</v-btn>
            </v-col>
            <v-col cols="12" md="2" lg="1">
              <v-btn color="success" @click="importDialog = true, importFile = []" class="mt-1">{{ $t('message.common.import') }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <template v-if="listOfSupplierItems && listOfSupplierItems.length > 0">
        <v-container fluid class="pa-0 supplier">
          <v-simple-table dense class="elevation-1 bordered--table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" v-for="(head, index) in costHeaders" :key="index">
                    {{ head.text }}
                  </th>
                  <th>{{ $t('message.mailConfiguration.action') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listOfSupplierItems" :key="item.id">
                  <td>
                    <v-icon v-if="item.ismain">check</v-icon>
                  </td>
                  <td>{{ item.customer_name }}</td>
                  <td>{{ item.articlenumber }}</td>
                  <td>{{ item.articlename }}</td>
                  <td>{{ item.currencylist_name }}</td>
                  <td class="text-right">{{ item.supplierprice }}</td>
                  <td class="text-right">{{ item.supplierdiscount }}</td>
                  <td class="text-right">{{ item.discounted }}</td>
                  <td class="text-right">{{ item.other }}</td>
                  <td class="text-right">{{ item.shipmentaddon }}</td>
                  <!-- <td class="text-right">{{ item.realcost }}</td> -->
                  <td class="text-right">{{ item.realcostnok }}</td>
                  <td>
                    <v-icon color="success" @click="editSupplierItemHandler(item.id)">colorize</v-icon>
                    <v-icon color="error" @click="checkIfStockUsed(item)">delete_outline</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </template>
      <v-alert prominent text v-else type="info" class="mt-2" >
        <v-row align="center">
          <v-col class="grow">{{ $t('message.common.noResults') }}</v-col>
          <v-col class="shrink">
            <v-btn color="primary" @click="addNewSupplier">{{ $t('message.common.addNew') }}</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-expansion-panel-content>
    <v-dialog v-model="supplierDialog" width="800" persistent>
      <form-data :references.sync="supplierItemsReference" :model="supplierModel" ref="costItemReference"></form-data>
    </v-dialog>
    <!-- Import Dialog -->
    <v-dialog persistent max-width="600px" v-model="importDialog">
      <v-card>
        <v-card-title>
          <h3>{{$t('message.common.importSuppliers')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="importForm" :key="importDialog">
            <v-row>
              <v-col cols="12" lg="12">
                <v-file-input :label="$t('message.product.chooseFile')" accept=".xlsx, .xls" outlined v-model="importFile" hide-details></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-end">
            <v-btn color="info" @click="importFileHandler" :loading="loader">{{$t('message.common.import')}}</v-btn>
            <v-btn color="error" @click="importDialog = false, $refs.importForm.reset()">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-expansion-panel>
</template>
<script>
import FormTemplate from '../../components/FormTemplate'
import { mapState } from 'vuex'
export default {
  props: {
    model: {
      type: Object
    },
    list: {
      type: Object
    },
    isAdmin: {
      type: Boolean
    }
  },
  data () {
    return {
      isMain: '',
      listOfSupplierItems: [],
      supplierDialog: false,
      supplierLoading: false,
      supplierModel: {
        supplierprice: '',
        supplierdiscount: '',
        discounted: '',
        shipmentaddon: '',
        other: '',
        realcost: '',
        realcostnok: '',
        currencyid: '',
        ismain: true
      },
      initStage: false,
      priceLoading: false,
      totalPriceLoading: false,
      importDialog: false,
      loader: false,
      supplierExportLoading: false,
      importFile: [],
      totalExchangeAmount: 0,
      supplierTransformList: ['supplierprice', 'supplierdiscount', 'discounted', 'shipmentaddon', 'other', 'realcost', 'realcostnok']
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    supplierItemsReference () {
      return {
        title: this.supplierModel.id ? this.$t('message.product.updateSupplierItem') : this.$t('message.product.addSupplierItem'),
        properties: [{
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          label: this.$t('message.order.supplier'),
          items: this.list.suppliers,
          select_text: 'name',
          select_value: 'id',
          disabled: !!this.supplierModel.id,
          class: 'lg4 sm6'
        }, {
          model: 'articlenumber',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.product.articleNumber'),
          class: 'lg4 sm6'
        }, {
          model: 'articlename',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.product.articleName'),
          class: 'lg4 sm6'
        }, {
          model: 'leadtime',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.product.leadTime'),
          class: 'lg2 sm3',
          change: this.changesMade
        }, {
          model: 'currencyid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          label: this.$t('message.product.currency'),
          items: this.list.currencies,
          select_text: 'name',
          select_value: 'id',
          class: 'lg3 sm6',
          disabled: !this.isAdmin,
          change: this.getCurrencyExAmount
        }, {
          model: 'supplierprice',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_norwegianNumberValidation,
          label: this.$t('message.product.supplierPrice'),
          change: this.calculateDiscounted,
          disabled: !this.isAdmin,
          class: 'lg3 sm6'
        }, {
          model: 'supplierdiscount',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_discountValidation,
          label: this.$t('message.product.supplierDiscount'),
          change: this.calculateDiscounted,
          disabled: !this.isAdmin,
          class: 'lg2 sm6'
        }, {
          model: 'discounted',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_norwegianNumberValidation,
          label: this.$t('message.product.discounted'),
          change: this.calculateRealCost,
          disabled: !this.isAdmin,
          class: 'lg2 sm6'
        }, {
          model: 'typeofother',
          type: this.FORM_TYPE.RADIO,
          rules: this.$_requiredValidation,
          label: this.$t('message.product.typeOfOther'),
          items: this.list.priceTypes,
          is_show: true,
          select_text: 'text',
          select_value: 'value',
          class: 'lg3 sm6',
          disabled: !this.isAdmin,
          click: this.calculateRealCost
        }, {
          model: 'other',
          loading: this.priceLoading,
          type: this.FORM_TYPE.TEXT,
          rules: this.$_norwegianNumberValidation,
          label: this.$t('message.product.other'),
          change: this.calculateRealCost,
          disabled: !this.isAdmin,
          class: 'lg2 sm6'
        }, {
          model: 'typeofshipment',
          type: this.FORM_TYPE.RADIO,
          rules: this.$_requiredValidation,
          label: this.$t('message.product.typeOfShipment'),
          items: this.list.priceTypes,
          is_show: true,
          select_text: 'text',
          select_value: 'value',
          class: 'lg3 sm6',
          disabled: !this.isAdmin,
          click: this.calculateRealCost
        }, {
          model: 'shipmentaddon',
          type: this.FORM_TYPE.TEXT,
          loading: this.priceLoading,
          rules: this.$_norwegianNumberValidation,
          label: this.$t('message.product.shipmentAddon'),
          change: this.calculateRealCost,
          disabled: !this.isAdmin,
          class: 'lg2 sm6'
        },
        // {
        //   model: 'realcost',
        //   type: this.FORM_TYPE.TEXT,
        //   rules: this.$_norwegianNumberValidation,
        //   label: this.$t('message.product.realCost'),
        //   class: 'lg3 sm6',
        //   disabled: !this.isAdmin,
        //   change: this.calculateRealCost
        // },
        {
          model: 'realcostnok',
          type: this.FORM_TYPE.TEXT,
          loading: this.totalPriceLoading,
          rules: this.$_norwegianNumberValidation,
          label: this.$t('message.product.realCostNOK'),
          disabled: !this.isAdmin,
          class: 'lg3 sm6'
        }, {
          model: 'ismain',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 sm6 my-auto',
          label: this.$t('message.product.isMain')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.supplierModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateSupplierItemHandler(),
          loading: this.supplierLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewSupplier(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    costHeaders () {
      return [{
        text: this.$t('message.product.isMain')
      }, {
        text: this.$t('message.order.supplier')
      }, {
        text: this.$t('message.product.articleNumber')
      }, {
        text: this.$t('message.product.articleName')
      }, {
        text: this.$t('message.product.currency')
      }, {
        text: this.$t('message.product.supplierPrice')
      }, {
        text: this.$t('message.product.supplierDiscount')
      }, {
        text: this.$t('message.product.discounted')
      }, {
        text: this.$t('message.product.other')
      }, {
        text: this.$t('message.product.shipmentAddon')
      }, {
        text: this.$t('message.product.realCostNOK')
      }]
    }
  },
  watch: {
    'supplierModel.supplierid' (val) {
      if (!this.supplierModel.id && val) {
        this.setShipmentOtherPrice()
        this.setLeadTime()
      }
    }
  },
  mounted () {
    this.getAllSupplierItemHandler()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === 'productsuppliers') {
        this.getAllSupplierItemHandler()
      }
    })
  },
  methods: {
    setShipmentOtherPrice () {
      this.priceLoading = true
      this.$_executeApi('get', `transportationcosts/get_price_values/${this.supplierModel.supplierid}/${this.model.productgroupid || 0}`)
        .then((response) => {
          if (response.data) {
            let transformData = { number: { list: ['shipment', 'other'], format: 'replaceDotWithComma' } }
            let model = this.$_formatModel(response.data, transformData)
            this.supplierModel.shipmentaddon = model.shipment || ''
            this.supplierModel.other = model.other || ''
          } else {
            this.supplierModel.shipmentaddon = ''
            this.supplierModel.other = ''
          }
        })
        .finally(() => {
          this.priceLoading = false
        })
    },
    setLeadTime () {
      const getSupplier = this.list.suppliers.find(x => x.id === this.supplierModel.supplierid)
      if (getSupplier != null) {
        this.supplierModel.leadtime = getSupplier.leadtime || 1
      } else this.supplierModel.leadtime = 1
    },
    calculateDiscounted () {
      let price = this.supplierModel.supplierprice ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierprice) : 0
      let discount = this.supplierModel.supplierdiscount ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierdiscount) : 0
      let total = price * (100 - discount) / 100
      this.supplierModel.discounted = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
      this.calculateRealCost()
    },
    async calculateRealCost () {
      if (!this.initStage) {
        let discounted = this.supplierModel.discounted ? this.$formatter.replaceCommaWithDot(this.supplierModel.discounted) : 0
        let shipmentaddon = this.supplierModel.shipmentaddon ? this.$formatter.replaceCommaWithDot(this.supplierModel.shipmentaddon) : 0
        let other = this.supplierModel.other ? this.$formatter.replaceCommaWithDot(this.supplierModel.other) : 0
        let priceCalcOther = 0
        let total = +discounted * this.totalExchangeAmount
        if (this.supplierModel.typeofother === '%') {
          priceCalcOther = (+other + 100) / 100
          total = total * priceCalcOther
        } else if (this.supplierModel.typeofother === 'NOK') {
          priceCalcOther = +other
          total = total + priceCalcOther
        }
        let priceCalcShipment = 0
        if (this.supplierModel.typeofshipment === '%') {
          priceCalcShipment = (+shipmentaddon + 100) / 100
          total = total * priceCalcShipment
        } else if (this.supplierModel.typeofshipment === 'NOK') {
          priceCalcShipment = +shipmentaddon
          total = total + priceCalcShipment
        }
        this.supplierModel.realcost = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
        this.supplierModel.realcostnok = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
      }
    },
    getCurrencyExAmount () {
      if (this.supplierModel.currencyid) {
        this.totalPriceLoading = true
        this.$_executeApi('get', `/currencies/get_exchange_rate/${this.supplierModel.currencyid}`)
          .then((response) => {
            this.totalPriceLoading = false
            this.totalExchangeAmount = response.data
            this.calculateRealCost()
          })
      }
    },
    getAllSupplierItemHandler () {
      let query = {
        'expand': [{
          'Model': 'Customer',
          'on_field': 'Id',
          'on_parent_field': 'supplierid',
          'select': ['Name']
        }, {
          'select': ['name'],
          'model': 'CurrencyList',
          'on_field': 'Id',
          'on_parent_field': 'currencyid'
        }],
        'order_by': {
          'field': 'ismain',
          'asc_or_desc': 'desc'
        },
        'filter': `productid eq ${this.model.id}`
      }
      this.$_executeApi('post', `productsuppliers/query`, query)
        .then((response) => {
          let transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
          let model = this.$_formatListModel(response.data, transformData)
          this.listOfSupplierItems = model
        })
    },
    addNewSupplier () {
      this.supplierDialog = true
      let hasMainSupplier = this.listOfSupplierItems.find(x => x.ismain)
      this.supplierModel.ismain = hasMainSupplier ? false : true
      this.supplierModel.supplierprice = '0'
      this.supplierModel.supplierdiscount = '0'
      this.supplierModel.typeofother = '%'
      this.supplierModel.typeofshipment = '%'
      this.getCurrencyExAmount()
    },
    editSupplierItemHandler (id) {
      this.$_executeApi('get', `productsuppliers/${id}`)
        .then((response) => {
          let transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
          let model = this.$_formatModel(response.data, transformData)
          this.initStage = true
          this.supplierModel = model
          setTimeout(() => {
            this.initStage = false
          }, 100)
          this.supplierDialog = true
          this.getCurrencyExAmount()
        })
    },
    saveUpdateSupplierItemHandler () {
      if (this.$refs.costItemReference.$refs.validateForm.validate()) {
        this.supplierLoading = true
        let transformData = { number: { list: this.supplierTransformList, format: 'replaceCommaWithDot' } }
        let model = this.$_formatModel(this.supplierModel, transformData)
        model.productid = this.model.id
        if (!model.leadtime) model.leadtime = null
        this.$_saveUpdateHandler('productsuppliers', model)
          .then((response) => {
            if (model.ismain) this.$eventBus.$emit('updatedSupplier', model)
            this.closeAddNewSupplier()
            this.getAllSupplierItemHandler()
          })
          .finally(() => {
            this.supplierLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    checkIfStockUsed (item) {
      this.$_executeApi('get', `productsuppliers/check_stock_used/${item.supplierid}/${this.model.id}`)
        .then(response => {
          if (response && !response.data) {
            this.deleteSupplierItemHandler(item.id)
          } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.unableToDelete') })
        })
    },
    deleteSupplierItemHandler (id) {
      let ids = [id]
      let payload = { ids, url: `productsuppliers/delete_multiple`, module: 'productsuppliers' }
      this.$store.commit('showDeleteDialog', payload)
    },
    closeAddNewSupplier () {
      this.supplierDialog = false
      this.supplierModel.id = undefined
      this.$refs.costItemReference.$refs.validateForm.reset()
    },
    exportSuppliers () {
      this.supplierExportLoading = true
      this.$_executeApi('post', `products/export_suppliers?productId=${this.model.id}`)
        .then((response) => {
          this.$_downloadExportedReport(response.data).then(() => { this.supplierExportLoading = false })
        })
    },
    importFileHandler () {
      let file = this.importFile
      var formData = new FormData()
      formData.append(file.name, file)
      this.loader = true
      this.$_executeApi('post', `products/import_from_excel?type=2`, formData).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.importSuccess') })
        this.importFile = []
        this.$refs.importForm.reset()
        this.importDialog = false
        this.getAllSupplierItemHandler()
      }).finally(() => {
        this.loader = false
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
